import { Card as MUICard, IconButton } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { MoreVertRounded } from '@material-ui/icons';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { Link as RRLink } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      display: 'flex',
      margin: theme.spacing(0, 0, 1.5, 0),
      '&:last-child': {
        marginBottom: 0
      },
      width: '100%',
      border: '2px solid',
      borderColor: theme.palette.background.paper,
      borderRadius: 16,
      transition: '0.4s',
      '&:hover, &.Mui-focusVisible': {
        borderColor: theme.palette.primary.main
      }
    },
    container: {
      display: 'flex',
      flexGrow: 1,
      textDecoration: 'none',
      color: theme.palette.text.primary,
      [theme.breakpoints.down('xs')]: {
        display: 'block'
      }
    },
    paddingTopBottomLeft: {
      padding: theme.spacing(1, 0, 1, 1.5)
    },
    paddingTopBottomRight: {
      padding: theme.spacing(1, 1, 1, 0)
    },
    paddingRight: {
      paddingRight: theme.spacing(1.5)
    }
  })
);

interface CardProps {
  to: string;
  children: ReactNode;
  openDrawer?: (event: React.KeyboardEvent | React.MouseEvent) => void;
}

export default function Card({ to, children, openDrawer }: CardProps) {
  const classes = useStyles();

  return (
    <MUICard className={classes.card}>
      <RRLink
        className={clsx(classes.container, classes.paddingTopBottomLeft, {
          [classes.paddingRight]: !openDrawer
        })}
        to={to}
      >
        {children}
      </RRLink>
      {openDrawer && (
        <div className={classes.paddingTopBottomRight}>
          <IconButton size="small" onClick={openDrawer}>
            <MoreVertRounded />
          </IconButton>
        </div>
      )}
    </MUICard>
  );
}
